import { PrivacyLevel } from './PrivacyLevel';

export default class TeamSettings {
    public memberResultsPrivacyLevel: PrivacyLevel = PrivacyLevel.Member;
    public allExpensesPrivacyLevel: PrivacyLevel = PrivacyLevel.Member;
    public defaultGroupPrivacyLevel: PrivacyLevel = PrivacyLevel.Member;
}
